import { Maybe } from '@Types'

const workTypeTypes = [
    'bulk',
    'work',
    'history',
    'draft',
    'create-form',
    'create-wizard',
    'claim-wizard',
    'overclaim',
] as const
export type WorkType = (typeof workTypeTypes)[number]

export const isValidWorkType = (type: Maybe<string>): type is WorkType => {
    if (!type) {
        return false
    }
    const s: readonly string[] = workTypeTypes
    return s.includes(type)
}
